import { getColorCssValue } from '../../../../../element/utils/elementColorStyleUtils';
import { getIsLowContrastColorWithInterface } from '../../../../../../common/colors/colorComparisonUtil';
import { ColorButtonProps } from './popup/ColorButton';
import { isObject } from 'lodash';

export const resolveColorData = (color: ColorButtonProps['color']) => {
    if (!color) return { colorCss: null, colorName: null };

    if (isObject(color)) {
        return {
            colorCss: color.css,
            colorName: color.name,
        };
    }

    return {
        colorCss: getColorCssValue(color),
        colorName: color,
    };
};

type ColorButtonContrastProps = {
    colorCss: string | null;
    isDarkModeTheme: boolean;
    isMobileAppMode: boolean;
};

export const getColorButtonContrast = ({ colorCss, isDarkModeTheme, isMobileAppMode }: ColorButtonContrastProps) => {
    const defaultColorIsLowContrast = isMobileAppMode ? true : !isDarkModeTheme;

    if (!colorCss) {
        return {
            isLowContrastColor: defaultColorIsLowContrast,
            isHighContrastColor: !defaultColorIsLowContrast,
        };
    }

    return {
        isLowContrastColor: getIsLowContrastColorWithInterface(colorCss, isDarkModeTheme),
        isHighContrastColor: getIsLowContrastColorWithInterface(colorCss, !isDarkModeTheme),
    };
};
